<template>
    <div class="ForgotPassword">
        <div class="container">
            <h2>Reset Password</h2>

            <el-alert title="There was an error in updating your password" type="error" v-if="error"
                :description="error.message" show-icon>
            </el-alert>
            <el-alert title="Password has been updated successfully" type="success" v-if="success"
                :description="success.message" show-icon>
            </el-alert>

            <el-form :model="form" status-icon ref="form" label-width="120px" class="demo-ruleForm" :rules="rules"
                @submit.native.prevent
                :label-position="labelPosition">
                <el-form-item prop="email">
                    <el-input v-model="form.email" autocomplete="off" @keyup.enter.native="submitForm('form')" placeholder="Your Email" prefix-icon="el-icon-message"></el-input>
                </el-form-item>
                    <el-form-item label="Enter your new password" prop="password">
                    <el-input type="password" v-model="form.password" autocomplete="off" @keyup.enter.native="submitForm('form')"></el-input>
                </el-form-item>
                <el-form-item label="Confirm new password" prop="password_confirmation">
                    <el-input type="password" v-model="form.password_confirmation" autocomplete="off" @keyup.enter.native="submitForm('form')"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button class="ForgotPassword__Button" type="primary" @click="submitForm('form')" :loading="loading">Update Password</el-button>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>
<script>
    export default {
        components: {
        },
        data() {
            var validatePassword = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error('Please input the password'));
                } else {
                    if (this.form.password_confirmation !== '') {
                        this.$refs.form.validateField('password_confirmation');
                    }
                    callback();
                }
            };
            var validatePassword2 = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error('Please input the password again'));
                } else if (value !== this.form.password) {
                    callback(new Error('Two inputs don\'t match!'));
                } else {
                    callback();
                }
            };
            return {
                labelPosition: 'top',
                error: '',
                success: '',
                loading: false,
                form: {
                    email: '',
                    password: '',
                    password_confirmation: '',
                },
                rules: {
                    password: [
                        { validator: validatePassword, trigger: 'change', required: true},
                        { min: 8, message:'Length should be at least 8' }
                    ],
                    password_confirmation: [
                        { validator: validatePassword2, trigger: 'change', required: true },
                        { min: 8, message: 'Length should be at least 8' }
                    ],
                    email: [
                        { required: true, message: 'Please input email address', trigger: 'blur' },
                        { type: 'email', message: 'Please input correct email address', trigger: ['blur', 'change'] }
                    ]
                }
            }
        },
        methods: {
            submitForm(form) {
                event.preventDefault()
                this.$refs[form].validate((valid) => {
                    if(valid){
                        this.error = ''
                        this.success = ''
                        this.loading = true
                        const params = {
                            token: this.$route.params.token,
                            email: this.form.email,
                            password: this.form.password,
                            password_confirmation: this.form.password_confirmation
                        }
                        const promise = this.$store.dispatch('user/resetPassword', params);
                        promise
                        .then(resp => {
                            this.success = resp
                        })
                        .catch(error => {
                            this.error = error
                        })
                        .finally(() => {
                            this.loading = false
                        })
                    }else{
                        return false;
                    }
                });
            }
        },
        head: {
            title: function() {
                return {
                    inner: 'Create New Password'
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    .ForgotPassword {
        padding: 1em 0;

        form {
            max-width: 300px;
            margin: 0 auto;

            .el-form-item {
                margin-top: 1em!important;

                &.is-error {
                    margin-bottom: 1.5em!important;
                }
            }

            .bottom-links {
                margin-top: .5em!important;
            }

            .navigation__navitem {
                padding: 0;
                color: $alternate-color;

                &.forgot-password {
                    float: right;
                }
            }
        }

        h2 {
            text-align: center;
        }

        &__Button {
            width: 100%;
        }
    }
</style>